module.exports = __webpack_public_path__ + "static/media/termsOfUse.dc28a14d.pdf";